'use strict';

const _rl = require('./resolve-localized');
const {resolveLocalized, DEFAULT_LOCALE} = _rl.default || _rl;

const pickNonEmpty = (obj, key) => {
	if (!obj || obj[key] == null) return undefined;
	const v = obj[key];
	if (typeof v === 'string' && v.trim() === '') return undefined;
	if (typeof v === 'number' && Number.isNaN(v)) return undefined;
	return v;
};

const mergeAddress = (primary, fallback) => {
	const a = primary || {};
	const b = fallback || {};
	const out = {};
	['street', 'city', 'zip', 'country'].forEach(k => {
		const v = pickNonEmpty(a, k);
		out[k] = v !== undefined ? v : pickNonEmpty(b, k);
	});
	const pickGeo = geo => {
		if (!geo) return undefined;
		const lat = pickNonEmpty(geo, 'lat');
		const lng = pickNonEmpty(geo, 'lng');
		if (lat === undefined && lng === undefined) return undefined;
		// (0, 0) is the form/API empty sentinel — fall through to profile coords
		if (Number(lat) === 0 && Number(lng) === 0) return undefined;
		return {lat, lng};
	};
	const geo = pickGeo(a.geo) || pickGeo(b && b.geo);
	if (geo) out.geo = geo;
	return out;
};

const resolveVenue = (event, lang) => {
	const venue = (event && event.venue) || {};
	const profile = venue.profile && typeof venue.profile === 'object' ? venue.profile : null;
	const name = resolveLocalized(venue.name, lang)
		|| (profile ? resolveLocalized(profile.fullName, lang) : '')
		|| '';
	const address = mergeAddress(venue.address, profile && profile.address);
	return {name, address, profile};
};

const formatAddressLine = address => {
	if (!address) return '';
	const cityZip = [address.city, address.zip].filter(Boolean).join(' ').trim();
	return [address.street, cityZip, address.country].filter(Boolean).join(', ');
};

const formatLocation = resolved => {
	if (!resolved) return '';
	const addr = formatAddressLine(resolved.address);
	return [resolved.name, addr].filter(Boolean).join(', ');
};

const hasUsableGeo = address => {
	const geo = address && address.geo;
	if (!geo || geo.lat == null || geo.lng == null) return false;
	const lat = Number(geo.lat);
	const lng = Number(geo.lng);
	if (Number.isNaN(lat) || Number.isNaN(lng)) return false;
	if (lat === 0 && lng === 0) return false;
	return true;
};

const addressHasContent = address => {
	if (!address) return false;
	return Boolean(
		address.street || address.city || address.zip || address.country
		|| hasUsableGeo(address)
	);
};

module.exports = {
	mergeAddress,
	resolveVenue,
	formatAddressLine,
	formatLocation,
	addressHasContent,
	DEFAULT_LOCALE
};
